import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
          light: {
            primary: "#2d90d3",//'#AC1F62',
            secondary:  '#25313E',
            tertiary: '#41586E',
            accent: '#AC1F62',
            error: '#f55a4e',
            info: '#00d3ee',
            success: "#68BE9F",//#5cb860',
            warning: '#ffa21a',
            lightgray: '#f0f0f0'
          },
        },
      }
});
